import { render, staticRenderFns } from "./popGoodsAfter.vue?vue&type=template&id=160cd568"
import script from "./popGoodsAfter.vue?vue&type=script&lang=js"
export * from "./popGoodsAfter.vue?vue&type=script&lang=js"
import style0 from "./popGoodsAfter.vue?vue&type=style&index=0&id=160cd568&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('160cd568')) {
      api.createRecord('160cd568', component.options)
    } else {
      api.reload('160cd568', component.options)
    }
    module.hot.accept("./popGoodsAfter.vue?vue&type=template&id=160cd568", function () {
      api.rerender('160cd568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/saleOrder/components/popGoodsAfter/popGoodsAfter.vue"
export default component.exports